import TypeManager from "./TypeManager";

export default function BillingRoles() {
  return (
    <TypeManager
      title="Billing Roles"
      subtitle="Manage billing roles for landman assignments and client rate configuration."
      apiPath="BillingRoles"
      nameField="roleName"
      idField="id"
      feature="billing_controls"
      minLevel="advanced"
    />
  );
}
